import { GamesStorageType, PlexSetGamesArgs } from '../../types';

type PlexSetGamesStateFormatter = (
  args: PlexSetGamesArgs & { state: GamesStorageType }
) => GamesStorageType;

export const plexSetGamesStateFormatter: PlexSetGamesStateFormatter = ({
  games,
  launchIdToGameId,
  ids,
  state
}) => {
  return {
    ...state,
    games: {
      ...state.games,
      data: {
        ...state.games.data,
        ...Object.entries(games).reduce(
          (acc, [gameId, gameData]) => ({
            ...acc,
            [gameId]: { ...(state.games.data[gameId] ?? {}), ...gameData }
          }),
          {}
        )
      },
      launchIdToGameId: {
        ...launchIdToGameId,
        ...state.games.launchIdToGameId
      },
      ids: [...new Set([...(state.games.ids ?? []), ...ids])]
    }
  };
};
